<template>
  <v-app>
    <v-card>
      <v-card-title>
        Белая книга
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="course"
          :search="search"
      ></v-data-table>
    </v-card>
  </v-app>
</template>
<script>
export default {
  name: 'exam_index',
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'Наименование онлайн-курса',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Дисциплина к перезачету в АмГУ ', value: 'discipline' },
        { text: 'Вуз правообладатель', value: 'author' },
        { text: 'Направление подготовки, в рамках которой может быть перезачтен онлайн-курс в АмГУ', value: 'edu_prog' },
        { text: 'Платформа ', value: 'site' },
      ],
      course: [
        {
          name: 'Институциональная экономика',
          discipline: 'Институциональная экономика',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '38.03.01. Экономика (Финансы и кредит) \n' +
              '38.03.02 Менеджмент (Менеджмент организации) ',
          site: 'https://online.fa.ru/local/course/index.php?id=21',
        },
        {
          name: 'Финансовые рынки',
          discipline: 'Финансовые рынки \n' +
              'Финансовые рынки и финансово-кредитные институты ',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '38.03.01. Экономика (Финансы и кредит)',
          site: 'https://online.fa.ru/local/course/index.php?id=85',
        },
        {
          name: 'Обеспечение противодействия коррупции ',
          discipline: 'Финансовые рынки',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '38.05.01 Экономическая безопасность ',
          site: 'https://online.fa.ru/local/course/index.php?id=66',
        },
        {
          name: 'Макроэкономический анализ и регулирование банковской сферы ',
          discipline: 'Банковское дело',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '38.03.01. Экономика (Финансы и кредит)',
          site: 'https://online.fa.ru/local/course/index.php?id=61',
        },
        {
          name: 'Юридическая ответственность за финансово-экономические нарушения ',
          discipline: 'Налогообложение физических и юридических лиц',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '38.03.01. Экономика (Финансы и кредит)',
          site: 'https://online.fa.ru/local/course/index.php?id=93',
        },
        {
          name: 'Digital-маркетинг ',
          discipline: 'Маркетинг',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '38.03.01. Экономика (Финансы и кредит) \n' +
              '38.03.02 Менеджмент (Менеджмент организации) \n' +
              '38.05.01 Экономическая безопасность ',
          site: 'https://online.fa.ru/local/course/index.php?id=3',
        },
        {
          name: 'Digital-маркетинг ',
          discipline: 'Основы маркетинга',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '42.03.01 Реклама и связи с общественностью ',
          site: 'https://online.fa.ru/local/course/index.php?id=3',
        },
        {
          name: 'Управление эффективностью и результативностью в органах власти ',
          discipline: 'Теория и механизмы государственного управления ',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '38.04.04 Государственное и муниципальное управление (Региональное и муниципальное управление) ',
          site: 'https://online.fa.ru/local/course/index.php?id=84',
        },
        {
          name: 'Связи с общественностью в политике и бизнесе',
          discipline: 'Связи с общественностью в органах власти ',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '38.03.04 Государственное и муниципальное управление ',
          site: 'https://online.fa.ru/local/course/index.php?id=74',
        },
        {
          name: 'Гендерная социология и социальная реальность ',
          discipline: 'Социология',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '39.03.01 Социология',
          site: 'https://online.fa.ru/local/course/index.php?id=17',
        },
        {
          name: 'Теория игр и социально-экономическое поведение ',
          discipline: 'Теория игр и исследование операций ',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '01.03.02 Прикладная математика и информатика',
          site: 'https://online.fa.ru/local/course/index.php?id=80',
        },
        {
          name: 'Стратегический менеджмент ',
          discipline: 'Стратегический менеджмент ',
          author: 'Финансовый университет при Правительстве РФ',
          edu_prog: '38.03.02 Менеджмент (Менеджмент организации)',
          site: 'https://online.fa.ru/local/course/index.php?id=78',
        },
        {
          name: 'Взаимодействие государства и бизнеса в условиях цифровой трансформации ',
          discipline: 'Информационно-коммуникационные технологии в управлении ',
          author: 'Уральский федеральный университет им. первого Президента России Б.Н. Ельцина',
          edu_prog: '42.04.01 Реклама и связи с общественностью ',
          site: 'https://openedu.ru/course/urfu/GOVBUSINESS/',
        },
        {
          name: '«Методы оптико-микроскопических исследований руд»',
          discipline: 'факультатив ',
          author: 'Российский государственный геологоразведочный университет имени Серго Орджоникидзе (МГРИ) ',
          edu_prog: '21.05.02 «Прикладная геология», специализация «Геологическая съёмка, поиски и разведка месторождений твердых полезных ископаемых»',
          site: 'https://open.mgri.ru/courses/course-v1:MGRI+UOP_2+25122020/about',
        },
        {
          name: '«Современные инструментальные методы анализа минералов, пород и руд» ',
          discipline: 'Лабораторные методы изучения минерального сырья',
          author: 'Российский государственный геологоразведочный университет имени Серго Орджоникидзе (МГРИ) ',
          edu_prog: '21.05.02 «Прикладная геология», специализация «Геологическая съёмка, поиски и разведка месторождений твердых полезных ископаемых»',
          site: 'https://open.mgri.ru/courses/course-v1:MGRI+UOP_1+2020_12/about',
        },
        {
          name: 'Программирование и разработка веб-приложений на Python в 2х-частях (2 курса) ',
          discipline: 'факультатив ',
          author: 'Университет ИТМО (Санкт-Петербург) ',
          edu_prog: '09.03.02 Информационные системы и технологии',
          site: 'https://openedu.ru/course/ITMOUniversity/PWADEV/',
        },
        {
          name: 'Программирование глубоких нейронных сетей на Python ',
          discipline: 'факультатив ',
          author: 'Уральский федеральный университет им. первого Президента России Б.Н. Ельцина',
          edu_prog: '09.03.01 Информатика и вычислительная техника',
          site: 'https://openedu.ru/course/urfu/PYDNN/',
        },
        {
          name: 'Информационные технологии и сервисы ',
          discipline: 'Информационные технологии в профессиональной и научной деятельности ',
          author: 'Уральский федеральный университет им. Первого президента России Б.Н. Ельцина ',
          edu_prog: '42.04.01 Реклама и связи с общественностью',
          site: 'https://openedu.ru/course/urfu/ITS/',
        },
        {
          name: 'Психология профессиональной успешности ',
          discipline: 'факультатив',
          author: 'Высшая школа экономики',
          edu_prog: '37.05.01 Клиническая психология',
          site: 'https://www.hse.ru/edu/courses/492550885',
        },
        {
          name: 'Нейрофизиология поведения ',
          discipline: 'факультатив',
          author: 'Высшая школа экономики',
          edu_prog: '37.05.01 Клиническая психология',
          site: 'https://openedu.ru/course/msu/NEUROPHYS/',
        },
        {
          name: 'Лидерство и командное развитие ',
          discipline: 'факультатив',
          author: 'ФГБОУ ВО «Новосибирский государственный университет экономики и управления ',
          edu_prog: 'Все',
          site: 'https://online.edu.ru/public/course?faces-redirect=true&cid=11093828',
        },
        {
          name: 'Финансовая математика',
          discipline: 'факультатив',
          author: 'ФГБОУ ВО «Новосибирский государственный университет экономики и управления ',
          edu_prog: 'Все',
          site: 'https://online.edu.ru/public/course?cid=11242080',
        },
        {
          name: 'Основы предпринимательства ',
          discipline: 'факультатив',
          author: 'ФГБОУ ВО «Новосибирский государственный университет экономики и управления ',
          edu_prog: 'Все',
          site: 'https://online.edu.ru/public/course?faces-redirect=true&cid=11093828',
        },
        {
          name: 'Бизнес-коммуникации ',
          discipline: 'факультатив',
          author: 'ФГБОУ ВО «Новосибирский государственный университет экономики и управления ',
          edu_prog: 'Все',
          site: 'https://online.edu.ru/public/course?cid=11242073',
        },
        {
          name: 'Деловой иностранный язык ',
          discipline: 'факультатив',
          author: 'ФГБОУ ВО «Новосибирский государственный университет экономики и управления ',
          edu_prog: 'Все',
          site: 'https://online.edu.ru/public/course?cid=11242090',
        },
      ],
    }
  },
}

</script>
<style scoped>

</style>